// extracted by mini-css-extract-plugin
export default {"svg":"tick_svg__c6hnP","path":"tick_path__TOQIg","circle":"tick_circle__EdSuD","dash":"tick_dash__Iap5L","check":"tick_check__rzi+p","dash-check":"tick_dash-check__PL5VD"};